import { render, staticRenderFns } from "./AccountInformationB2b.vue?vue&type=template&id=45743d32&scoped=true&"
import script from "./AccountInformationB2b.vue?vue&type=script&lang=js&"
export * from "./AccountInformationB2b.vue?vue&type=script&lang=js&"
import style0 from "./AccountInformationB2b.vue?vue&type=style&index=0&id=45743d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45743d32",
  null
  
)

export default component.exports